import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Radio from '@mui/material/Radio';
import { Tooltip, Typography } from 'ui-kit';

import { Wrapper } from './styles';

export interface ISortData {
    label: string;
    sortType: string;
    orderBy: string;
    id: string | null;
}

export interface ISortLabel {
    total: number | null;
    data?: ISortData[];
    id: string;
    label: string;
    sort: {
        orderBy: string;
        sortType: string;
        id: string | null;
    } | null;

    handleChange: ({ sortType, orderBy, id }: { sortType: string; orderBy: string; id: string | null }) => void;
}
export const SortLabel = (props: ISortLabel) => {
    const { total, data, handleChange, sort, id, label } = props;
    return (
        <Wrapper className={!total ? 'table-cell-sortable no-data' : 'table-cell-sortable'}>
            <Tooltip
                className="table-sort-tooltip"
                disableTouchListener
                title={
                    <div>
                        {data?.map(el => {
                            return (
                                <div
                                    className="table-sort-tooltip-item"
                                    key={el.label}
                                    onClick={() => handleChange(el)}
                                >
                                    <Typography variant="body1">
                                        <Radio checked={sort ? sort.orderBy === el.orderBy && sort.sortType === el.sortType : false} />
                                        {el.label}
                                    </Typography>
                                </div>
                            );
                        })}
                    </div>
                }
            >
                <div className={sort && id === sort.id ? 'sortableCell hasSort' : 'sortableCell'}>
                    <span>{label}</span>
                    <span
                        className={`sortIcons ${
                            sort && id === sort.id && sort.sortType === 'ASC'
                                ? 'sortIcons_ASC'
                                : sort && id === sort.id && sort.sortType === 'DESC'
                                ? 'sortIcons_DESC'
                                : ''
                        }`}
                    >
                        <ArrowDropUpIcon className="sortIcons_up" />
                        <ArrowDropDownIcon className="sortIcons_down" />
                    </span>
                </div>
            </Tooltip>
        </Wrapper>
    );
};
